import React from 'react';
import { Button } from 'components/Misc/Form';

import { useExamReviewStore } from 'store/exam/useExamReviewStore';

const Upload = ({ files }) => {
	// Use exam review store
	const slug = useExamReviewStore(state => state.student.slug);

	return (
		<div className="flex flex-col gap-4">
			{files?.map(file =>
				<div key={file.id} className="py-2 px-2 flex items-center border border-neutral-200 dark:border-neutral-700 rounded-lg transition-colors">
					<div className="flex-1 text-neutral-800 dark:text-white transition-colors">
						{file.name}
					</div>

					<Button
						small
						square
						download
						icon="download"
						toOutside={`${process.env.REACT_APP_CDN}/users/${slug}/${file.name}`}
					/>
				</div>
			)}
		</div>
	);
};

export default Upload;